// if (window.location.hostname == "yimattbp.xyz" || window.location.hostname == "www.yimattbp.xyz") { window.location.href = "https://dirtylabs.com"; };

function instantBuy(evt) {
  if ($(evt).hasClass('pdp-buynow')) {
    var get_form_data = $(evt).closest('.pdp-form').serializeArray();
    $.ajax({
      url: "/cart/add",
      type: "post",
      data: get_form_data,
      success: function() {
        window.location.href = "/checkout";
      },
      error: function() {
      }
    });
  } else {
    var get_item_id = $(evt).attr('data-add-id');
    $.ajax({
      url: "/cart/add",
      type: "post",
      data: {id: get_item_id, quantity: 1},
      success: function() { 
        window.location.href = "/checkout";
      },
      error: function() {
      }
    });
  }
  return false;
} 

$(document).ready(function() {
  $(document).on('click', '#klaviyo-form-wrapper #klaviyo-product .ql-editor a', function(e) {
    e.preventDefault();
    $(this).closest('#klaviyo-form-wrapper').remove();
    return false;
  });

  $(document).on('keypress', '#klaviyo-form-wrapper #klaviyo-product input', function(e) {
    if(e.keyCode == 13) {
      e.preventDefault();
      $('#klaviyo-form-wrapper #klaviyo-product button').click();
    }
  })
  
  var typing_timer;
  $(document).on('keyup', '.cart--notes--textarea', function() {
    var note = $(this).val();
    clearTimeout(typing_timer);
    typing_timer = setTimeout(function() {
      clearTimeout(typing_timer);
      $.ajax({
        url: '/cart/update.js',
        method: 'POST',
        data: { note: note },
        success: function(result) { 
          //console.log(result);
        },
        error: function(jqxhr, status, exception) {
          console.log(exception);
        }
      }); 
    }, 700);
  });


  $(document).on('click', '.shopify-section.logo-list button', function() {
    var $item = $(this).closest('.shopify-section.logo-list').find('.logo-item');
    $item.toggleClass('visible');
    $(this).closest('.action-button').toggleClass('expanded');
  })

  $(document).on('click', '.custom-dropdown > label', function() {
    $(this).closest('.custom-dropdown').toggleClass('open');
  })

  $(document).on('click', '.custom-dropdown li', function(){
    var handle = $(this).attr('value');
    $('.reviews-wrapper [data-review]').removeClass('active');
    var $target = $('.reviews-wrapper [data-review="' + handle + '"]');
    $target.addClass('active');
    $(this).closest('.custom-dropdown').removeClass('open');

    $(this).closest('.custom-dropdown').find('label').text($(this).text());
  })
  
  $('.sticky-product-details .sticky-product-close').on('click', function() {
    $('.header--sticky--product').animate({
      'bottom': '-100%'
    }, 750, function() {
      $(this).remove();
    });
  });

  /* Autoshipment experiment */

  // Recursion function
  var recurseOverNodes = (node, callback) => {
    // Skip script elements
    if(['SCRIPT', 'NOSCRIPT', 'IFRAME', 'META', 'STYLE', 'BR', 'IMG', 'svg'].indexOf(node.nodeName) > -1) return false;

    // Skip when node text is empty (this could cause hidden content to be skipped)
    if(node.innerText === '') return false

    // Skip when node length is less than smallest replacement target
    if(node.nodeType === Node.TEXT_NODE && node.nodeValue && node.nodeValue.length < 9) return false;

    if(node.nodeType === Node.ELEMENT_NODE) {
      // Skip FAQ, policies, account, loyalty lab, tools (recharge portal)
      if(node.matches(`
        [data-pathname^="/pages/frequently-asked-questions"] .main-content,
        [data-pathname^="/policies"] .main-content,
        [data-pathname^="/account"] .main-content,
        [data-pathname^="/pages/loyalty-program"] .main-content,
        [data-pathname^="/tools"] .main-content
      `)) return false;
      // Skip newsletter subscription elements, reviews
      if(node.matches('.footer--subscribe--content, .junip-product-review')) return false;
    }

    // Recurse on nodes with child nodes
    if(node.childNodes.length > 0) {
      return Array.from(node.childNodes).flatMap(child => recurseOverNodes(child, callback))
    }

    // Return callback on node
    return callback ? callback(node) : node
  }

  // Recurse, replacing texts as necessary
  var autoshipReplacement = (root) => {
    if(!window.autoship) return;

    recurseOverNodes(root, (node) => {
      if(node.nodeType === Node.TEXT_NODE) {
        var initialText = node.nodeValue.slice(0);
        var newText = node.nodeValue.slice(0);
        newText = newText.replaceAll(/Subscribe/g, 'Autoship');
        newText = newText.replaceAll(/subscribe/g, 'autoship');
        newText = newText.replaceAll(/Subscriptions/g, 'Autoship');
        newText = newText.replaceAll(/subscriptions/g, 'autoship');
        newText = newText.replaceAll(/Subscription/g, 'Autoship');
        newText = newText.replaceAll(/subscription/g, 'autoship');
        newText = newText.replaceAll(/ a autoship/g, ' an autoship');

        if(initialText === newText) return false;

        node.nodeValue = newText;

        // Return
        return newText;
      }
    });
  };

  /* Recurse within ReCharge widgets only */
  // var replaceInWidgets = () => {
  //   var widgets = document.querySelectorAll('.rc-container-wrapper');
  //   Array.from(widgets).forEach(widget => autoshipReplacement(widget));
  // };

  // Run on body
  // autoshipReplacement(document.body);

  /* Ensure autoship replacement occurs after ReCharge Widget Load */
  // reChargeWidgetAvailableCallback(() => {
  //   replaceInWidgets();
  //   setTimeout(replaceInWidgets, 250);
  //   setTimeout(replaceInWidgets, 500);
  //   setTimeout(replaceInWidgets, 750);
  //   setTimeout(replaceInWidgets, 1000);
  // });
  
  /* This script runs whenever a new selling plan interval is selected */
  $(document).on('change', '.rc-selling-plans__dropdown', function(e) {
    var productRoot = e.target.closest('[data-js-class="ProductPage"]');

    var newOption = productRoot.querySelector('option[value="' + e.target.value + '"]');
    var newOptionInterval = newOption.getAttribute('data-plan-option');

    productRoot.setAttribute('data-selling-plan-default-interval', newOptionInterval);
  });

  /* This script runs whenever a new selling plan is selected */
  $(document).on('change', '.rc-radio__input', function(e) {
    var productRoot = e.target.closest('[data-js-class="ProductPage"]');
    var $productRoot = $(productRoot);
    var addToCartText = $productRoot.find('#add .text');
    var buyNowText = $productRoot.find('.pdp-buynow .text');

    if(e.target.value === 'subsave') {
      addToCartText && addToCartText.text(theme.translations.add_subscription_to_cart);
      buyNowText && buyNowText.text(theme.translations.subscribe_now);

      /* When selling plan is selected, set interval to the most recently selected, or the default if present */
      var defaultIntervalOption = $productRoot.find('option[data-plan-option="' + productRoot.getAttribute('data-selling-plan-default-interval') + '"]')[0];
      if(defaultIntervalOption) defaultIntervalOption.selected = 'selected';

    } else if (e.target.value === 'onetime') {
      addToCartText && addToCartText.text(theme.translations.add_to_cart);
      buyNowText && buyNowText.text(theme.translations.buy_now);
    } else {
      console.warn('no value for selling plan');
    }
  });

  var replaceRechargeWidget = function(productWrapper, productId, variantId, products) {
    // linkedProductWrapper, productId, variantId, products
    var newLinkedProductRechargeWidget = productWrapper.find('.shopify-app-block.recharge-subscription-widget');
    var newLinkedProductRechargeWidgetHTML = newLinkedProductRechargeWidget.html();
    var updatedLinkedProductRechargeWidgetHTML = newLinkedProductRechargeWidgetHTML
      .replace(/product-id="\d+"/, 'product-id="' + productId + '"')
      .replace(/default-variant-id="\d+"/, 'default-variant-id="' + variantId + '"')
      .replace(/const filteredSellingPlans = [^;]+/, 'const filteredSellingPlans = ' + JSON.stringify(products[productId].json.selling_plan_groups))
      .replace(/formattedPrices: {[^;]+/, 'formattedPrices: ' + JSON.stringify(products[productId].variant_selling_plans) + '}');
    var newLinkedProductRechargeWidgetElement = document.createElement('div');
    newLinkedProductRechargeWidgetElement.classList.add('shopify-block', 'shopify-app-block', 'recharge-subscription-widget');
    newLinkedProductRechargeWidgetElement.innerHTML = updatedLinkedProductRechargeWidgetHTML
    newLinkedProductRechargeWidget.replaceWith(newLinkedProductRechargeWidgetElement);

    var rechargeWidgetStylesheet = document.querySelector('.recharge-widget-stylesheet');
    var newWidget = newLinkedProductRechargeWidgetElement.querySelector('recharge-subscription-widget');
    var newShadowRoot = newWidget.shadowRoot;
    // console.log(newLinkedProductRechargeWidgetElement, newWidget, newShadowRoot);
    newShadowRoot.appendChild(rechargeWidgetStylesheet.cloneNode(true));
  }

  /* This script runs only when a new variant is selected (not when selling plan changes) */
  Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(t, e, n) {
    // console.log(`variant change`, t, e, n);

    /* Identify product id */
    var productId = e.product.id;

    /* Identify first product media id as backup */
    var firstProductImageId = e.product.media.length > 0 ? e.product.media[0].id : undefined;

    /* Identify selected variant featured media id */
    var selectedFeaturedMediaId = t.hasOwnProperty('featured_media') ? t.featured_media.id : firstProductImageId;

    /* Constrain DOM manipulation to the relevant product root */
    /* This prevents side effects when working with linked products */
    var productRoot = $('[data-js-class="ProductPage"][data-product-id="' + productId + '"]');

    /* Identify root element with URL info */
    var linkedProductWrapper = $('.linked-product-wrapper[data-product-id="' + productId + '"]');

    /* Update root variant attribute so param can be preserved over linked product toggle */
    linkedProductWrapper.attr('data-variant-id', t.id);

    replaceRechargeWidget(linkedProductWrapper, productId, t.id, products);

    /* Update URL to reflect current variant, as of March 2024, ReCharge does not update variant info without this history state change */
    history.replaceState(history.state, '', linkedProductWrapper.attr('data-product-url') + '?variant=' + t.id);
    
    /* Identify all thumb containers (hide) */
    var allThumbContainers = productRoot.find('.product-page--thumb-container');
    
    /* Identify all thumbs (deactivate) */
    var allThumbs = productRoot.find('.product-page--thumb');

    /* Identify all main images (deactivate) */
    var allMainImage = productRoot.find('.product-page--media');

    /* Identify all variant pills (hide) */
    var allVariantPills = productRoot.find('.pill-container[data-variant]');

    /* Identify selected variant thumb containers (show) */
    var selectedThumbContainers = productRoot.find('.product-page--thumb-container[data-variant-id="' + t.id + '"]');

    /* Identify selected variant featured media thumb (activate) */
    var selectedFeaturedMediaThumb = productRoot.find('.product-page--thumb[data-id="' + selectedFeaturedMediaId + '"]');

    /* Identify selected variant featured media main image (activate) */
    var selectedFeaturedMediaMainImage = productRoot.find('.product-page--media[data-id="' + selectedFeaturedMediaId + '"]');

    /* Identify selected variant pills (show) */
    var selectedVariantPills = productRoot.find('.pill-container[data-variant-id="' + t.id + '"]');

    /* Identify use data store */
    var usesData = productRoot.find('[data-uses]');

    /* Identify use count */
    var usesCount = t.uses;

    /* Hide all thumb containers */
    allThumbContainers.addClass('hide');

    /* Deactivate all thumbs */
    allThumbs.attr('data-active', 'false');

    /* Deactivate all main images */
    allMainImage.attr('data-active', 'false');

    /* Hide all variant pills */
    allVariantPills.addClass('hide');

    /* Show thumb containers matching the selected variant id */
    selectedThumbContainers.removeClass('hide');

    /* Activate selected variant featured media thumb */
    selectedFeaturedMediaThumb.attr('data-active', 'true');

    /* Activate selected variant featured media main image */
    selectedFeaturedMediaMainImage.attr('data-active', 'true');

    /* Show selected variant pills */
    selectedVariantPills.removeClass('hide');

    /* Update last clicked id so we return to the correct image on mouseleave */
    productRoot.data('last-clicked-media-id', selectedFeaturedMediaId);

    /* Update use count */
    usesData.data('uses', usesCount);

    /* Do autoship replacement */
    // autoshipReplacement();
  };
})